import { useMemo, useState, useEffect } from "react";
import { Drawer, Sheet, Modal, Dialog } from "@virkesborsen/ui-component-library";

function DrawerWrapper({ open, onOpenChange, header, children, footer }) {
    return (
        <Drawer isOpen={open} onOpenChange={onOpenChange}>
            <Drawer.Header className="pb-2-5 justify-between items-center">{header}</Drawer.Header>
            <Drawer.Content className="pt-2">{children}</Drawer.Content>
            <Drawer.Footer>{footer}</Drawer.Footer>
        </Drawer>
    )
}

function SheetWrapper({ open, onOpenChange, header, children, footer }) {
    return (
        <Sheet isOpen={open} onOpenChange={onOpenChange} side={"right"}>
            <Sheet.Header className="justify-between items-center">{header}</Sheet.Header>
            <Sheet.Content>{children}</Sheet.Content>
            <Sheet.Footer>{footer}</Sheet.Footer>
        </Sheet>
    )
}
function ModalWrapper({ open, header, children, footer }) {
    return (
        <Modal isOpen={open}>
            <Modal.Header className="justify-between items-center">{header}</Modal.Header>
            <Modal.Content>{children}</Modal.Content>
            <Modal.Footer>{footer}</Modal.Footer>
        </Modal>
    )
}

function DialogWrapper({ open, header, children, footer }) {
    return (
        <Dialog isOpen={open} size='small'>
            <Dialog.Header className="justify-between items-center">{header}</Dialog.Header>
            <Dialog.Content>{children}</Dialog.Content>
            <Dialog.Footer>{footer}</Dialog.Footer>
        </Dialog>
    )
}




const useWindowWidth = () => {
    const BREAKPOINTS = { sm: 576, lg: 992 };
    const [screenSizes, setScreenSizes] = useState({ isSmall: false, isLarge: false });

    useEffect(() => {
        const smallMQL = window.matchMedia(`(max-width: ${BREAKPOINTS.sm}px)`);
        const largeMQL = window.matchMedia(`(min-width: ${BREAKPOINTS.lg}px)`);

        const updateScreenSizes = () => {
            setScreenSizes({
                isSmall: smallMQL.matches,
                isLarge: largeMQL.matches,
            });
        };

        updateScreenSizes();
        smallMQL.addEventListener('change', updateScreenSizes);
        largeMQL.addEventListener('change', updateScreenSizes);

        return () => {
            smallMQL.removeEventListener('change', updateScreenSizes);
            largeMQL.removeEventListener('change', updateScreenSizes);
        };
    }, []);

    return screenSizes;
};


export function DynamicModal({ bp = {}, ...props }) {
    const { isSmall, isLarge } = useWindowWidth();

    const activeModalType = useMemo(() => {
        if (isSmall && bp.sm) return bp.sm;

        if (isLarge && bp.lg) return bp.lg;

        return bp.sm;
    }, [isSmall, isLarge, bp.sm, bp.lg])



    const renderActiveModal = () => {
        switch (activeModalType) {
            case 'drawer':
                return <DrawerWrapper {...props} />
            case 'sheet':
                return <SheetWrapper {...props} />
            case 'dialog':
                return <DialogWrapper {...props} />
            default:
                return <ModalWrapper {...props} />
        }
    }


    return open ? renderActiveModal() : null;
}
